"use strict";

var _constants = require("../constants");
/**
 * A unique identifier stored in a cookie in the user's browser
 */

/**
 * String, account identifier (not legacy Int-only AccountId)
 */

/**
 * Unique numeric identifier of the typeform
 */

/**
 * the platform the typeform published to? represents the platform that the conversation was started on.
 */

/**
 * the platform the typeform was published to
 */

/**
 * whether the headers of the form were shown at render time. Only applies to standard embeds.
 */

/**
 * whether the footers of the form were shown at render time. Only applies to standard embeds.
 */

/**
 * true this respondent has been part of this conversation (this typeform). based on browser cookie
 */

/**
 * Unique text identifier of the typeform
 */

/**
 * the name of the actual page being visited
 */

/**
 * the name of the actual section being visited
 */

/**
 * a uuid according to RDC4222
 */

/**
 * unique identifier of this specific user session
 */

/**
 * unique identifier of this specific time the page is being visited
 */

/**
 * unique identifier of this specific time the section is being visited
 */

/**
 * context of the page being visited
 */

/**
 * Typeform version
 */

/**
 * the design element being changed
 */

/**
 * the previous value of the design element being changed
 */

/**
 * the new value of the design element being changed
 */

/**
 * Features with required value property
 */

/**
 * Features with required label property
 */

/**
 * Features with required limit_type property
 */

/**
 * Features with required limit_type property
 */

/**
 * Exact feature that is being used, on a specific page - section
 */

/**
 * value of the feature that is being set
 */

/**
 * meaningful error message
 */

/**
 * step of the integration setup procedure
 */

/**
 * step of using an integration
 */

/**
 * identifier of the service provider
 */

/**
 * identifier of the integration use case
 */

/**
 * 1 if the section is displayed by default when the user visits thepage, 0 if not. -1 if there is no section
 */

/**
 * Where the event occured. For example: 'admin'
 */

/**
 * Item where the action happens. For example: 'nag_screen_upgrade'
 */

/**
 * Type of the trigger item. For example: 'button'
 */

/**
 * NagScreen where the action happens. For example: 'integration_mailchimp'
 */

/**
 * block reference
 */

var eventOwnersAsValues = Object.values(_constants.TEAMS);

/**
 * Only to be used for the Product Taxonomy events FeatureDiscovered, FeatureActivated, FeatureFirstStepAdopted
 */

// other-feature